/* =========================================================
   JUMARY - triggerSuccessAnimation()
   Animación de "Compra exitosa" estilo Rappi: overlay oscuro
   de pantalla completa, checkmark que se dibuja solo, y texto
   con fade-in + scale-up. Dura ~2.5s y se retira sola.

   USO:
     triggerSuccessAnimation();
     triggerSuccessAnimation('¡Pedido confirmado!');
     triggerSuccessAnimation('¡Compra exitosa!', 'Te escribiremos por WhatsApp para coordinar la entrega.');
     triggerSuccessAnimation('¡Compra exitosa!', null, function(){
       // se ejecuta justo cuando el overlay ya se ocultó del todo
       document.querySelector('#mensaje-final').hidden = false;
     });
========================================================= */
function triggerSuccessAnimation(message, subMessage, onComplete){
  message = message || '¡Compra exitosa!';

  var overlay = document.querySelector('.jumary-success-overlay');

  if(!overlay){
    overlay = document.createElement('div');
    overlay.className = 'jumary-success-overlay';
    overlay.innerHTML =
      '<div class="jumary-success-content">' +
        '<div class="jumary-success-ring">' +
          '<div class="jumary-success-ring__inner">' +
            '<svg class="jumary-success-check" viewBox="0 0 52 52" fill="none">' +
              '<circle class="jumary-success-check__circle" cx="26" cy="26" r="23"/>' +
              '<path class="jumary-success-check__mark" d="M14 27l7 7 16-16"/>' +
            '</svg>' +
          '</div>' +
        '</div>' +
        '<div class="jumary-success-text"></div>' +
        '<div class="jumary-success-subtext"></div>' +
      '</div>';
    document.body.appendChild(overlay);
  }

  overlay.querySelector('.jumary-success-text').textContent = message;
  var subEl = overlay.querySelector('.jumary-success-subtext');
  if(subMessage){
    subEl.textContent = subMessage;
    subEl.style.display = '';
  } else {
    subEl.style.display = 'none';
  }

  // Reinicia las animaciones del checkmark aunque se llame dos veces seguidas.
  overlay.classList.remove('is-in');
  overlay.classList.add('is-visible');
  // Forzar reflow para que el navegador "vea" el estado inicial antes de animar.
  // eslint-disable-next-line no-unused-expressions
  overlay.offsetHeight;

  requestAnimationFrame(function(){
    overlay.classList.add('is-in');
  });

  var totalVisible = 2500; // duración total pedida, en milisegundos
  var fadeOut = 400;

  setTimeout(function(){
    overlay.classList.remove('is-in');
    overlay.classList.remove('is-visible');
    setTimeout(function(){
      if(typeof onComplete === 'function') onComplete();
    }, fadeOut);
  }, totalVisible - fadeOut);
}

/* =========================================================
   Dispara la animación en CUALQUIER botón de "agregar al
   carrito" del sitio (ficha de producto, quick-add en el
   catálogo, la barra flotante, y nuestras secciones JUMARY).
   No se activa en el checkout ni en la página de confirmación.
========================================================= */
(function(){
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || form.tagName !== 'FORM') return;
    var action = form.getAttribute('action') || '';
    if(action.indexOf('/cart/add') === -1) return;
    triggerSuccessAnimation('¡Agregado al carrito!');
  }, true);

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.sticky-add-to-cart__button');
    if(btn) triggerSuccessAnimation('¡Agregado al carrito!');
  }, true);
})();